import React, { Suspense, useEffect, useState } from "react";

import styled from "@emotion/styled";

const LazyPdfDocument = React.lazy(() => import("./wrapper"));

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;
const ScrollablePdfContainer = styled.div`
    display: flex;
    justify-self: center;
    overflow-x: auto;
    overflow-y: auto;
    white-space: nowrap;
    margin: auto;
    max-height: 60vh;
    ${({ theme }) => theme.breakpoints.upTo.medium.css`
       width: 100%;
    `}
`;

const ControlContainer = styled.div`
    padding: 0.5em;
    border-top: 1px solid ${({ theme }) => theme.colors.grey.toString()};
`;

const Controls = styled.div`
    display: flex;
    gap: 1em;
    justify-content: space-evenly;
`;

const NavButton = styled.button`
    all: unset;
    color: ${({ theme }) => theme.colors.red.toString()};
    text-decoration: underline;
    cursor: pointer;
`;

interface PdfDocumentProps {
    pdfPath: string;
    scale?: number;
}
const PdfDocument = ({ pdfPath, scale = 1.0 }: PdfDocumentProps) => {
    const [pageNumber, setPageNumber] = useState<number | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageLoaded, setPageLoaded] = useState<boolean>(false);

    useEffect(() => {
        setPageLoaded(true);
    }, []);

    const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
        setPageNumber(numPages);
    };

    const handleNext = (event: React.MouseEvent) => {
        event.preventDefault();
        // checks if it isn't the last page
        if (!pageNumber) {
            return;
        }
        if (currentPage < pageNumber) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = (event: React.MouseEvent) => {
        event.preventDefault();
        // checks if it isn't the first page
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    if (!pageLoaded) {
        return null;
    }

    return (
        <Suspense fallback="Pdf wird geleaden...">
            <Container>
                <ScrollablePdfContainer>
                    <LazyPdfDocument
                        pdfPath={pdfPath}
                        currentPage={currentPage}
                        handleLoadSuccess={handleLoadSuccess}
                        scale={scale}
                    />
                </ScrollablePdfContainer>

                <ControlContainer>
                    {pageNumber && pageNumber > 1 && (
                        <Controls>
                            <NavButton
                                onClick={(event: React.MouseEvent) =>
                                    handlePrevious(event)
                                }
                            >
                                Zurück
                            </NavButton>
                            {currentPage && (
                                <span>
                                    {currentPage} / {pageNumber}
                                </span>
                            )}
                            <NavButton
                                onClick={(event: React.MouseEvent) =>
                                    handleNext(event)
                                }
                            >
                                Vor
                            </NavButton>
                        </Controls>
                    )}
                </ControlContainer>
            </Container>
        </Suspense>
    );
};

export default PdfDocument;
